<template>
  <div class="product-purchase-tag" :class="{ 'product-purchase-tag--disabled': disabled }">
    <span
      v-if="showListPrice"
      class="product-purchase-tag__text product-purchase-tag__text--list-price"
      >{{ listPriceText }}</span
    >
    <span class="product-purchase-tag__text product-purchase-tag__text--price">{{
      priceText
    }}</span>
    <span
      v-if="showInstallments"
      class="product-purchase-tag__text product-purchase-tag__text--installments"
      >{{ installmentsText }}</span
    >
    <span
      v-if="showListPrice"
      class="product-purchase-tag__text product-purchase-tag__text--discounts"
      >{{ discountsText }}</span
    >
  </div>
</template>

<script>
import subtract from 'lodash/subtract';
import { mapGetters } from 'vuex';
import { getFormattedPrice } from '../../../utilities/vtex';

export default {
  name: 'product-purchase-tag',
  props: {
    product: {
      type: Object,
      required: false,
    },
    listPriceTemplate: {
      type: String,
      required: true,
    },
    priceTemplate: {
      type: String,
      required: true,
    },
    singlePriceTemplate: {
      type: String,
      required: true,
    },
    installmentsTemplate: {
      type: String,
      required: true,
    },
    discountsTemplate: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showListPrice() {
      if (!this.product) {
        return false;
      }

      return this.product.price.list > this.product.price.current;
    },
    showInstallments() {
      if (!this.product) {
        return false;
      }

      return this.product.installments.total > 1;
    },
    listPriceText() {
      if (!this.product) {
        return '';
      }

      return this.supplant(this.listPriceTemplate, {
        price: getFormattedPrice(this.culture, this.product.price.list),
      });
    },
    priceText() {
      if (!this.product) {
        return '';
      }

      return this.supplant(this.showListPrice ? this.priceTemplate : this.singlePriceTemplate, {
        price: getFormattedPrice(this.culture, this.product.price.current),
      });
    },
    installmentsText() {
      if (!this.product) {
        return '';
      }

      return this.supplant(this.installmentsTemplate, {
        total: this.product.installments.total,
        value: getFormattedPrice(this.culture, this.product.installments.value),
      });
    },
    discountsText() {
      if (!this.product) {
        return '';
      }

      return this.supplant(this.discountsTemplate, {
        discount: subtract(this.product.price.list, this.product.price.current).toFixed(2),
      });
    },
    ...mapGetters('cart', ['culture']),
  },
  mounted() {
    setTimeout(() => {
      this.dataLayerCall();
    }, 2000);
  },
  methods: {
    supplant(template, data) {
      return `${template}`.replace(/{([^{}]*)}/g, (value, index) => data[index]);
    },
    dataLayerCall() {
      dataLayer.forEach((el) => {
        if (el.eventAction == 'Product Detail') {
          el.ecommerce.detail.products.forEach((product) => {
            product['price'] = this.product['price']['current'] || 'none';
          });
        }
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" src="./product-purchase-tag.scss"></style>
